export default __webpack_public_path__ + "static/media/nft4.a48666b1.jpg";